<template>
  <div id="lockScreen">
    <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#showLockScreenModal" ref="btnShowLockScreen" v-show="false">
      Show Screen
    </button>

    <div class="modal" id="showLockScreenModal" tabindex="-1" role="dialog" aria-labelledby="showLockScreenModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static" style="z-index:1060">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" ref="btnHideLockScreen" v-show="closeBtnEnable">
        <span aria-hidden="true">&times;</span>
      </button> <span aria-hidden="true">&times;</span>
      <div class="modal-dialog modal-dialog-centered text-center" role="document">
        <div class="modal-content" v-show="false">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" ref="btnHideLockScreen">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <div :class="textColor + ' text-center'" style="width:100%; font-size: 20px;">
          <div :class="iconClassLockScreen" role="status">
            <span class="sr-only">Cargando...</span>
          </div>
          <span v-text="messageLockScreen"></span> 
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
export default {
  name: 'LockScreen',
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['closeBtnEnable', 'iconClassLockScreen', 'messageLockScreen', 'textColor'])
  },
  methods: {
  }
}</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
